import { NoShowReasonModel, INoShowReason } from "@core/models";

export const noShowReasonsMock = [
  {
    [INoShowReason.id]: "0123",
    [INoShowReason.label]: "Ne s’est pas présenté et a prévenu",
  },
  {
    [INoShowReason.id]: "0124",
    [INoShowReason.label]: "Ne s’est pas présenté et n'a pas prévenu",
  },
  {
    [INoShowReason.id]: "0125",
    [INoShowReason.label]: "Changement de planning vu avec l’extra",
  },
].map((noShowReason) => new NoShowReasonModel(noShowReason));
